'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.adapter = void 0;
var users_1 = require("./users");
var wallet_1 = require("./wallet");
var configs_1 = require("./configs");
var games_1 = require("./games");
var translations_1 = require("./translations");
var promotions_1 = require("./promotions");
var pages_1 = require("./pages");
var signup_1 = require("./signup");
var maintenance_1 = require("./maintenance");
var messages_1 = require("./messages");
var bonuses_1 = require("./bonuses");
var offers_1 = require("./offers");
var responsiblegaming_1 = require("./responsiblegaming");
var rewards_1 = require("./rewards");
var competitions_1 = require("./competitions");
var faqs_1 = require("./faqs");
var faqsCategories_1 = require("./faqsCategories");
var system_1 = require("./system");
var lottery_1 = require("./lottery");
var loyalty_1 = require("./loyalty");
var sitefeatures_1 = require("./sitefeatures");
var gamification_1 = require("./gamification");
var geoComply_1 = require("./geoComply");
var externalServices_1 = require("./externalServices");
var navigations_1 = require("./navigations");
var Adapter = /** @class */ (function () {
    function Adapter() {
        this.bonuses = new bonuses_1.Bonuses();
        this.competitions = new competitions_1.Competitions();
        this.users = new users_1.Users();
        this.wallet = new wallet_1.Wallet();
        this.configs = new configs_1.Configs();
        this.games = new games_1.Games();
        this.translations = new translations_1.Translations();
        this.promotions = new promotions_1.Promotions();
        this.pages = new pages_1.Pages();
        this.signup = new signup_1.Signup();
        this.maintenance = new maintenance_1.Maintenance();
        this.messages = new messages_1.Messages();
        this.navigations = new navigations_1.Navigations();
        this.offers = new offers_1.Offers();
        this.rewards = new rewards_1.Rewards();
        this.responsibleGaming = new responsiblegaming_1.ResponsibleGaming();
        this.faqs = new faqs_1.FAQs();
        this.faqsCategories = new faqsCategories_1.FAQsCategories();
        this.system = new system_1.System();
        this.lottery = new lottery_1.Lottery();
        this.loyalty = new loyalty_1.Loyalty();
        this.sitefeatures = new sitefeatures_1.SiteFeatures();
        this.gamification = new gamification_1.Gamification();
        this.geoComply = new geoComply_1.GeoComply();
        this.externalServices = new externalServices_1.ExternalServices();
    }
    return Adapter;
}());
exports.adapter = new Adapter();
